
const PATHS = {
    logo: (
        <path
            d="M6 17.5v-11h2.1l7.9 9.3V6.5H18v11h-2.1l-7.9-9.3v9.3z"
            fill="currentColor"
            stroke="none"
        />
    ),

    home: (
        <>
            <path d="M3 10.5 12 3l9 7.5" />
            <path d="M5 9.8V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.8" />
        </>
    ),
    users: (
        <>
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </>
    ),
    chart: (
        <>
            <path d="M3 3v16a2 2 0 0 0 2 2h16" />
            <path d="M7 15.5v-3" />
            <path d="M11.5 15.5V8" />
            <path d="M16 15.5v-5" />
            <path d="M20.5 15.5V5" />
        </>
    ),
    building: (
        <>
            <rect x="4" y="3" width="16" height="18" rx="1.5" />
            <path d="M9 8h2M13 8h2M9 12h2M13 12h2M9 16h2M13 16h2" />
        </>
    ),

    sun: (
        <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </>
    ),
    moon: <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />,
    monitor: (
        <>
            <rect x="2" y="3.5" width="20" height="13" rx="2" />
            <path d="M8 21h8M12 16.5V21" />
        </>
    ),

    plus: <path d="M12 5v14M5 12h14" />,
    pencil: (
        <>
            <path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" />
            <path d="m15 5 4 4" />
        </>
    ),
    trash: (
        <>
            <path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
            <path d="M10 11v6M14 11v6" />
        </>
    ),
    play: <path d="m7 4 12 8-12 8z" fill="currentColor" stroke="none" />,
    pause: (
        <>
            <rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor" stroke="none" />
            <rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor" stroke="none" />
        </>
    ),
    search: (
        <>
            <circle cx="11" cy="11" r="7" />
            <path d="m21 21-4.3-4.3" />
        </>
    ),
    close: <path d="M18 6 6 18M6 6l12 12" />,
    logout: (
        <>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <path d="m16 17 5-5-5-5M21 12H9" />
        </>
    ),
    check: <path d="m4 12.5 5 5L20 6.5" />,
    arrowRight: (
        <>
            <path d="M5 12h14" />
            <path d="m13 6 6 6-6 6" />
        </>
    ),
    menu: <path d="M4 6h16M4 12h16M4 18h16" />,
    refresh: (
        <>
            <path d="M21 12a9 9 0 1 1-2.6-6.4" />
            <path d="M21 3v6h-6" />
        </>
    ),

    clock: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3.5 2" />
        </>
    ),
    calendar: (
        <>
            <rect x="3" y="4.5" width="18" height="17" rx="2" />
            <path d="M8 2.5v4M16 2.5v4M3 10h18" />
        </>
    ),
    download: (
        <>
            <path d="M12 3v12" />
            <path d="m7 11 5 5 5-5" />
            <path d="M4 20h16" />
        </>
    ),
    fingerprint: (
        <>
            <path d="M12 4.5c-3 0-5.5 2.2-5.5 5.2 0 2.4.6 4.4 1.3 6" />
            <path d="M17.5 9.7c0-2.9-2.5-5.2-5.5-5.2" />
            <path d="M12 8.2c-1.2 0-2.2 1-2.2 2.2 0 3.8.9 6.9 2.2 9" />
            <path d="M14.2 10.4c0-1.2-1-2.2-2.2-2.2" />
            <path d="M17.3 13c.4 2.7.2 5.3-.8 7" />
            <path d="M9 21c-1-1.8-1.7-3.7-2-5.5" />
        </>
    ),
    key: (
        <>
            <circle cx="7.5" cy="15.5" r="4" />
            <path d="m10.3 12.7 8-8M17 3.5 20.5 7M14.5 6l3.5 3.5" />
        </>
    ),
    shield: <path d="M12 2.5 4 6v6c0 4.6 3.3 8 8 9.5 4.7-1.5 8-4.9 8-9.5V6z" />,
    sparkles: (
        <>
            <path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z" />
            <path d="M19 15l.9 2.1 2.1.9-2.1.9L19 21l-.9-2.1-2.1-.9 2.1-.9z" />
        </>
    ),
    mail: (
        <>
            <rect x="2.5" y="5" width="19" height="14" rx="2.5" />
            <path d="m3 7 9 6 9-6" />
        </>
    ),
    lock: (
        <>
            <rect x="4" y="10.5" width="16" height="10.5" rx="2" />
            <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
        </>
    ),
    eye: (
        <>
            <path d="M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12z" />
            <circle cx="12" cy="12" r="3" />
        </>
    ),
    eyeOff: (
        <>
            <path d="M10.6 6.1A10.9 10.9 0 0 1 12 6c6.5 0 10 6 10 6a17.5 17.5 0 0 1-3.1 3.8" />
            <path d="M6.1 7.1A17.4 17.4 0 0 0 2 12s3.5 6 10 6c1.4 0 2.7-.2 3.8-.6" />
            <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
            <path d="m3 3 18 18" />
        </>
    ),
    globe: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18z" />
        </>
    ),
    activity: <path d="M3 12h4l2.5-7 4 14 2.5-7h5" />,
    inbox: (
        <>
            <path d="M3 13h5l1.5 3h5L16 13h5" />
            <path d="M5 5h14l2 8v6H3v-6z" />
        </>
    ),
    alert: (
        <>
            <path d="M12 3 2.5 20h19z" />
            <path d="M12 9.5v4.5M12 17.2v.2" />
        </>
    ),
    info: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 11v5M12 8v.2" />
        </>
    ),
    file: (
        <>
            <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
            <path d="M14 3v5h5" />
        </>
    ),
    table2: (
        <>
            <rect x="3" y="4" width="18" height="16" rx="2" />
            <path d="M3 9.5h18M3 15h18M9.5 4v16" />
        </>
    ),
    zap: <path d="M13 2 4 14h6l-1 8 9-12h-6z" />,
    user: (
        <>
            <circle cx="12" cy="8" r="4.5" />
            <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
        </>
    ),
    chevronLeft: <path d="m14 6-6 6 6 6" />,
    chevronRight: <path d="m10 6 6 6-6 6" />,
    nfc: (
        <>
            <path d="M6 8.5a8 8 0 0 1 0 7" />
            <path d="M9.5 6.5a11 11 0 0 1 0 11" />
            <path d="M13 4.5a14.2 14.2 0 0 1 0 15" />
            <circle cx="4.5" cy="12" r="1.6" fill="currentColor" stroke="none" />
        </>
    ),
    backspace: (
        <>
            <path d="M9 5h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-6-7z" />
            <path d="m12.5 9.5 5 5M17.5 9.5l-5 5" />
        </>
    ),
    wifi: (
        <>
            <path d="M2.5 9a14.5 14.5 0 0 1 19 0" />
            <path d="M5.5 12.5a10 10 0 0 1 13 0" />
            <path d="M8.5 16a5.5 5.5 0 0 1 7 0" />
            <path d="M12 19.5v.2" />
        </>
    ),
    login: (
        <>
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
            <path d="m10 17 5-5-5-5" />
            <path d="M15 12H3" />
        </>
    ),
    hash: (
        <>
            <path d="M5 9h14M5 15h14" />
            <path d="M9.5 4 8 20M16 4l-1.5 16" />
        </>
    ),
    keypad: (
        <>
            <path d="M4 4h4v4H4zM10 4h4v4h-4zM16 4h4v4h-4z" />
            <path d="M4 10h4v4H4zM10 10h4v4h-4zM16 10h4v4h-4z" />
            <path d="M4 16h4v4H4zM10 16h4v4h-4zM16 16h4v4h-4z" />
        </>
    ),
};

export function Ico({ name, size = 18, className, style, strokeWidth = 1.8 }) {
    const content = PATHS[name];
    if (!content) return null;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            style={style}
            aria-hidden="true"
            focusable="false"
        >
            {content}
        </svg>
    );
}

export function BrandMark({ size = 40, radius = 12 }) {
    return (
        <div className="brand-mark" style={{ width: size, height: size, borderRadius: radius }}>
            <Ico name="logo" size={Math.round(size * 0.52)} strokeWidth={0} />
        </div>
    );
}

export default Ico;
